<h2 mat-dialog-title>
  <mat-icon svgIcon="handshake"></mat-icon>
  Kickback-politikker
</h2>
<button class="btn-close btn-icon" mat-dialog-close>
  <mat-icon class="material-icons">close</mat-icon>
</button>

<mat-dialog-content>
  <ok-feedback-info>
    <p>
      Kickback beløbet modtager virksomheden pr. kWh for ALLE ladninger, baseret på de forskellige satser for normal-, hurtig- og
      lynladning.
    </p>
  </ok-feedback-info>

  <div class="multi-select margin--bottom-none">
    <div class="multi-select__list multi-select__list--grid">
      @if (kickbacks$ | async; as kickbacks) {
        @if (kickbacks.length > 0) {
          <div class="multi-select__headers">
            <div class="multi-select__item--name">Navn</div>
            <div class="multi-select__item--rate">
              Normal (AC)
              <svg class="icon-20 margin--left-xs cursor-help" [matTooltip]="'AC ladestandere med Type2 stik'">
                <use href="assets/images/ok-icons-sprite.svg#info-s"></use>
              </svg>
            </div>
            <div class="multi-select__item--rate">
              Hurtig (DC)
              <svg class="icon-20 margin--left-xs cursor-help" [matTooltip]="'DC ladestandere med CCS stik under 100 kW'">
                <use href="assets/images/ok-icons-sprite.svg#info-s"></use>
              </svg>
            </div>
            <div class="multi-select__item--rate">
              Lyn (DC)
              <svg class="icon-20 margin--left-xs cursor-help" [matTooltip]="'DC ladestandere med CCS stik over 100 kW'">
                <use href="assets/images/ok-icons-sprite.svg#info-s"></use>
              </svg>
            </div>
            <div></div>
            <div></div>
          </div>
          @for (kickback of kickbacks; track kickback.id) {
            <div class="multi-select__item multi-select__item--tall" [class.highlight]="kickback.id === editingKickback()?.id">
              <div class="multi-select__item--name">
                <span>{{ kickback.name }}</span>
              </div>
              <div class="multi-select__item--rate">
                <span>{{ kickback.normalRateInKronerExVat | dkCurrency }}</span>
              </div>
              <div class="multi-select__item--rate">
                <span>{{ kickback.fastRateInKronerExVat | dkCurrency }}</span>
              </div>
              <div class="multi-select__item--rate">
                <span>{{ kickback.superRateInKronerExVat | dkCurrency }}</span>
              </div>
              <button mat-icon-button title="Rediger" type="button" (click)="edit(kickback)">
                <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#edit-s"></use></svg>
              </button>
              <button mat-icon-button class="delete" title="Fjern" type="button" (click)="softDelete(kickback.id)">
                <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#trash-s"></use></svg>
              </button>
            </div>
          }
        }
      }
      <div class="multi-select__input">
        <form class="filter-dropdown" [formGroup]="kickbackFormGroup">
          <mat-form-field>
            <mat-label>Navn</mat-label>
            <input matInput formControlName="name" />
          </mat-form-field>
          <adm-price-unit-input [control]="kickbackFormGroup.controls.normalRate" [label]="'Normal'" [hint]="'Ekskl. moms'" />
          <adm-price-unit-input [control]="kickbackFormGroup.controls.fastRate" [label]="'Hurtig'" [hint]="'Ekskl. moms'" />
          <adm-price-unit-input [control]="kickbackFormGroup.controls.superRate" [label]="'Lyn'" [hint]="'Ekskl. moms'" />
          @if (editingKickback()) {
            <button mat-flat-button color="primary" (click)="saveEdit()" class="add-button" [disabled]="kickbackFormGroup.invalid">
              Gem
            </button>
            <button mat-icon-button (click)="cancelEdit()" class="cancel-button" [matTooltip]="'Annuller redigering'">
              <svg class="icon-20"><use href="assets/images/ok-icons-sprite.svg#close-s"></use></svg>
            </button>
          } @else {
            <button mat-flat-button color="primary" (click)="create()" class="add-button" [disabled]="kickbackFormGroup.invalid">
              <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#plus-s"></use></svg>
            </button>
          }
        </form>
      </div>
    </div>
  </div>

  <mat-dialog-actions>
    <div class="unit-identifier">
      <span>Organisationsnavn:</span>
      {{ data.organizationName }}
    </div>
    <button mat-dialog-close type="button" mat-button>Luk</button>
  </mat-dialog-actions>
</mat-dialog-content>
